import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";

import Popup from "../Popup";

import {
  getProfileCreatedByList,
  getHeightList,
  getWeightList,
  getMaritalStatusList,
  addMaritalStatus,
  addChildrenDetails,
  submitBasicDetails,
  submitDobTime,
  submitHeightWeight,
} from "../../javaAxiosConfig";

import { WheelScroller } from "./WheelScroller";

import EducationProfessionFlow from "./EducationProfessionFlow";
import NativeAddressFlow from "./NativeAddressFlow";

import FamilyDetailsFlow from "./FamilyDetailsFlow";
import PhotoUploadFlow from "./PhotoUploadFlow";

import PrivacySettingFlow from "./PrivacySettingFlow";

import { PROFILE_UI_CONTENT } from "./profileContextContent";

import { resolveProfileUIText } from "./resolveProfileUIText";

import dayjs from "dayjs";

import RegistrationStepLayout from "./RegistrationStepLayout";
import javaAxiosInstance from "../../javaAxiosConfig";

// ICONS
import profileCreatedByIcon from "../../images/profilecreatedby.png";
import yourNameEmailIcon from "../../images/yournameandemail.png";
import selectGenderIcon from "../../images/SelectGender.png";
import checkSmallIcon from "../../images/checkSmall.png";
import calendarIcon from "../../images/calendarIcon.png";
import MaritalStatusIcon from "../../images/MaritalStatus.png";
import YourHeightIcon from "../../images/YourHeight.png";
import ChildrenDetailsIcon from "../../images/ChildrenDetails.png";

import infoIcon from "../../images/i-buton.png";
import upArrow from "../../images/updropArrow.png";
import downArrow from "../../images/downdropArrow.png";
import searchIcon from "../../images/searchIcon.svg";

// IMAGES
import ladkiImg from "../../images/ladki.png";
import ladkaImg from "../../images/ladka.png";

const getStepText = (uiText, step) => uiText?.[step] || {};

/* =====================================================
   PARENT
===================================================== */



const RegisterBasicDetails = ({ onCompleted }) => {
  // const cameFromLogin =
  //   localStorage.getItem("resumeMode") === "true" &&
  //   localStorage.getItem("loginType") === "login";

  // // const [uiStep, setUiStep] = useState(1);
  // useEffect(() => {
  //   if (!cameFromLogin) {
  //     // NORMAL REGISTRATION
  //     localStorage.removeItem("resumeMode");
  //     console.log("[RBD] Normal registration → resume disabled");
  //   } else {
  //     console.log("[RBD] Resume registration detected");
  //   }
  // }, []);


  useEffect(() => {
  const isResume =
    localStorage.getItem("resumeMode") === "true" &&
    localStorage.getItem("loginType") === "login";

  if (isResume) {
    console.log("[RBD] Resume registration detected");
  } else {
    console.log("[RBD] Normal registration");
  }
}, []);

//   useEffect(() => {
//   const isResume =
//     localStorage.getItem("resumeMode") === "true" &&
//     localStorage.getItem("loginType") === "login";

//   if (isResume) {
//     console.log("[RBD] Resume registration detected");

//     // 🔥 CRITICAL FIX — reset resume after entry
//     localStorage.setItem("resumeMode", "false");
//   } else {
//     console.log("[RBD] Normal registration → resume disabled");
//     localStorage.removeItem("resumeMode");
//   }
// }, []);

  const [uiStep, setUiStep] = useState(() => {
    const isFresh =
      !localStorage.getItem("token") &&
      !localStorage.getItem("registrationProgress");

    if (isFresh) return 1;

    return Number(localStorage.getItem("basic_ui_step")) || 1;
  });

  const [slideClass, setSlideClass] = useState("");
const prevStepRef = useRef(uiStep);

useEffect(() => {
  if (prevStepRef.current === uiStep) return;

  const isForward = uiStep > prevStepRef.current;

  setSlideClass(isForward ? "slide-forward" : "slide-backward");

  const timer = setTimeout(() => {
    setSlideClass("");
  }, 500);

  prevStepRef.current = uiStep;

  return () => clearTimeout(timer);
}, [uiStep]);



  const location = useLocation();

  // true ONLY when user starts registration from scratch
  const isFreshRegistration =
    !localStorage.getItem("token") &&
    !localStorage.getItem("registrationProgress");

  useEffect(() => {
    if (!isFreshRegistration) return;

    console.log("[RBD] Fresh registration → full reset");

    localStorage.removeItem("resumeMode");
    localStorage.removeItem("registrationProgress");
    localStorage.removeItem("basic_ui_step");
    // localStorage.removeItem("education_sub_step");
    localStorage.removeItem("basic_name_email");
    localStorage.removeItem("profileCreatedById");
    localStorage.removeItem("selectedGender");

    setProfileCreatedById(null);
    setMaritalStatus(null);

    setBasicData({
      profileId: null,
      first_name: "",
      last_name: "",
      email: "",
      mobileNumber: "",
      gender: "",
      dateOfBirth: "",
      timeOfBirth: "",
    });

    setUiStep(1);
  }, [isFreshRegistration]);

  const navigate = useNavigate();

  const [maritalStatus, setMaritalStatus] = useState(null);

  const [profileCreatedById, setProfileCreatedById] = useState(null);

  const [showBackConfirm, setShowBackConfirm] = useState(false);
  const backTriggeredRef = useRef(false);

  const [dobMode, setDobMode] = useState("DATE");

  useEffect(() => {
    const handleBackNavigation = () => {
      // Prevent infinite loop
      if (backTriggeredRef.current) return;

      backTriggeredRef.current = true;

      // Push history forward so page doesn't change
      window.history.pushState(null, "", window.location.href);

      // Show confirmation popup
      setShowBackConfirm(true);
    };

    // Push initial state
    window.history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", handleBackNavigation);

    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, []);

  // useEffect(() => {
  //   if (isFreshRegistration) return;

  //   const savedProfileId = localStorage.getItem("profileCreatedById");
  //   if (savedProfileId) {
  //     setProfileCreatedById(Number(savedProfileId));
  //     setBasicData((p) => ({ ...p, profileId: Number(savedProfileId) }));
  //   }
  // }, [isFreshRegistration]);

  useEffect(() => {
    if (isFreshRegistration) return;

    // 1️⃣ Restore gender for LOGIN RESUME (🔥 MISSING PIECE)
    const genderFromApi = localStorage.getItem("gender"); // set at OTP/login
    if (genderFromApi) {
      localStorage.setItem("selectedGender", genderFromApi);
    }

    // 2️⃣ Try numeric ID first (normal registration)
    const savedProfileId = localStorage.getItem("profileCreatedById");
    if (savedProfileId) {
      const id = Number(savedProfileId);
      setProfileCreatedById(id);
      setBasicData((p) => ({ ...p, profileId: id }));
      return;
    }

    // 3️⃣ LOGIN RESUME → map registerBy string to ID
    const registerByStr = localStorage.getItem("registerBy");
    if (!registerByStr) return;

    const REGISTER_BY_MAP = {
      Self: 1,
      Guardian: 2,
      Guardians: 2,
      Friends: 3,
      Others: 4,
      Father: 5,
      Mother: 6,
      Brother: 7,
      Sister: 8,
    };

    const mappedId = REGISTER_BY_MAP[registerByStr];
    if (!mappedId) return;

    localStorage.setItem("profileCreatedById", mappedId);
    setProfileCreatedById(mappedId);
    setBasicData((p) => ({ ...p, profileId: mappedId }));
  }, [isFreshRegistration]);

  const confirmExitRegistration = () => {
    // Clear auth + registration state
    localStorage.removeItem("token");
    localStorage.removeItem("registrationProgress");
    localStorage.removeItem("register_registration_data");

    // Hide modal
    setShowBackConfirm(false);

    // Redirect & replace history (blocks forward)
    navigate("/otpLogin", { replace: true });
  };

  const cancelExitRegistration = () => {
    setShowBackConfirm(false);
    backTriggeredRef.current = false; // allow future back attempts
  };

  const uiText =
    PROFILE_UI_CONTENT[profileCreatedById] || PROFILE_UI_CONTENT[1]; // fallback = Self

  useEffect(() => {
    if (isFreshRegistration) return;

    const progress = localStorage.getItem("registrationProgress");

    // ❗ ONLY restore basic_ui_step for BASIC FLOW
    const BASIC_FLOW_PROGRESS = [
      "BASIC_DETAILS_CHECK",
      "DATE_OF_BIRTH_CHECK",
      "MARITAL_STATUS_CHECK",
    ];

    if (BASIC_FLOW_PROGRESS.includes(progress)) {
      const savedUiStep = Number(localStorage.getItem("basic_ui_step"));
      if (savedUiStep && savedUiStep > 0) {
        setUiStep(savedUiStep);
        return;
      }
    }
    // const progress = localStorage.getItem("registrationProgress");

    const PROGRESS_TO_UI_STEP = {
      BASIC_DETAILS_CHECK: 4, // DOB
      DATE_OF_BIRTH_CHECK: 5, // Marital
      MARITAL_STATUS_CHECK: 7, // Height
      HEIGHT_AND_WEIGHT_CHECK: 8, // Education flow

      // 👇 BOTH should point to EducationProfessionFlow
      EDUCATION_PROFESSION_INCOME_CHECK: 8,
      LIVING_IN_CHECK: 9,

      // 👇 Only after education + living-in is complete
      NATIVE_ADDRESS_CHECK: 9,
      COUMMUNITY_DETAILS_CHECK: 10,

      FAMILY_DETAILS_CHECK: 11,
      PHOTO_UPLOAD_CHECK: 12,
    };

    if (
  progress === "COUMMUNITY_DETAILS_CHECK" ||
  progress === "FAMILY_DETAILS_CHECK" ||
  progress === "PHOTO_UPLOAD_CHECK"
) {
  navigate("/my_matches");
  return;
}

    setUiStep(PROGRESS_TO_UI_STEP[progress] || 1);
  }, []);

  const [basicData, setBasicData] = useState({
    profileId: null,
    first_name: "",
    last_name: "",
    email: "",
    mobileNumber: "",
    gender: "",

    dateOfBirth: "",
    timeOfBirth: "",
  });

  const back = () => {
    const p = Math.max(1, uiStep - 1);
    setUiStep(p);
    localStorage.setItem("basic_ui_step", p);
  };

  const next = () => {
    const n = uiStep + 1;
    setUiStep(n);
    localStorage.setItem("basic_ui_step", n);
  };

  const backFromHeight = () => {
    if (maritalStatus === "Unmarried" || maritalStatus === "Annulled") {
      setUiStep(5); // 👈 go back to Marital Status
    } else {
      setUiStep(6); // 👈 go back to Children Details
    }
  };

  console.log("[RBD] render", {
    uiStep,
    registrationProgress: localStorage.getItem("registrationProgress"),
    resumeMode: localStorage.getItem("resumeMode"),
    isFreshRegistration,
  });

  const STEP_KEY_MAP = {
    1: "PROFILE_CREATED_BY",
    2: "GENDER",
    3: "NAME_EMAIL",
    4: "DOB",
    5: "MARITAL_STATUS",
    6: "CHILDREN",
    7: "HEIGHT",
  };

  const gender = localStorage.getItem("selectedGender");

  const getResolvedText = (step) => {
    const stepKey = STEP_KEY_MAP[step];
    const stepConfig = PROFILE_UI_CONTENT[stepKey];

    if (!stepConfig) return {};

    return resolveProfileUIText({
      profileCreatedById,
      gender,
      stepKey,
      stepConfig,
    });
  };

  return (
    <>

    <div className={`registration-anim-wrapper ${slideClass}`}>
      {uiStep === 1 && (
        <ProfileCreatedBy
          uiText={uiText}
          value={basicData.profileId}
          onNext={next}
          onSelect={(profileId) => {
            setProfileCreatedById(profileId);
            setBasicData((p) => ({ ...p, profileId }));
            localStorage.setItem("profileCreatedById", profileId);
          }}
        />
      )}

      {uiStep === 2 &&
        (() => {
          const resolved = getResolvedText(2);

          return (
            <Gender
              onBack={back}
              value={basicData.gender}
              title={resolved.title}
              subtitle={resolved.subtitle}
              onSubmit={(gender) => {
                setBasicData((p) => ({ ...p, gender }));
                localStorage.setItem("selectedGender", gender);
                next();
              }}
            />
          );
        })()}

      {uiStep === 3 &&
        (() => {
          const resolved = getResolvedText(3);

          return (
            <NameEmail
              onBack={back}
              title={resolved.title}
              subtitle={resolved.subtitle}
              onNext={next}
              onChange={(data) => setBasicData((p) => ({ ...p, ...data }))}
              onSubmit={async (form) => {
                const payload = {
                  registerBy: basicData.profileId,
                  first_name: form.first_name,
                  last_name: form.last_name,
                  email: form.email || null,
                  alternateMobileNumber: form.mobileNumber || null,
                  gender: basicData.gender,
                  devicePlatform: "web",
                  appVersion: null,
                };

                const res = await submitBasicDetails(payload);
                const username = res?.data?.username;
                if (username) {
                  const genderFromUsername = username.startsWith("M")
                    ? "M"
                    : "F";
                  localStorage.setItem("profileGender", genderFromUsername);
                }
              }}
            />
          );
        })()}

      {uiStep === 4 &&
        (() => {
          const stepKey = dobMode === "TIME" ? "DOB_TIME" : "DOB_DATE";

          const resolved = resolveProfileUIText({
            profileCreatedById,
            gender,
            stepKey,
            stepConfig: PROFILE_UI_CONTENT[stepKey],
          });

          return (
            <DobTimeStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              onModeChange={setDobMode}
              onBack={null}
              onSubmit={async ({ dateOfBirth, timeOfBirth }) => {
                await submitDobTime({
                  dateOfBirth,
                  timeOfBirth: timeOfBirth || "",
                });
                next();
              }}
            />
          );
        })()}

      {uiStep === 5 &&
        (() => {
          const resolved = getResolvedText(5);

          return (
            <MaritalStatusStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              onBack={back}
              onNext={(status) => {
                setMaritalStatus(status);

                if (status === "Unmarried" || status === "Annulled") {
                  setUiStep(7);
                } else {
                  setUiStep(6);
                }
              }}
            />
          );
        })()}


      {uiStep === 6 &&
        (() => {
          const resolved = getResolvedText(6);

          return (
            <ChildrenDetailsStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              onBack={back}
              onNext={next}
            />
          );
        })()}

      {uiStep === 7 &&
        (() => {
          const resolved = getResolvedText(7);

          return (
            <HeightWeightStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              maritalStatus={maritalStatus}
              onBack={backFromHeight}
              onSubmit={() => {
                const resumeMode = localStorage.getItem("resumeMode");

                console.group("[HEIGHT SUBMIT]");
                console.log("resumeMode:", resumeMode);
                console.log("isFreshRegistration:", isFreshRegistration);
                console.groupEnd();

                

                localStorage.removeItem("basic_ui_step");
                next(); // 👉 go to EducationProfessionFlow
              }}
            />
          );
        })()}

      {uiStep === 8 && (
        <EducationProfessionFlow
          isFresh={isFreshRegistration}
          onCompleted={() => {
            console.log("[RBD] Education completed → moving to NativeAddress");
            setUiStep(9);
          }}
        />
      )}

      {uiStep === 9 && (
        <NativeAddressFlow
        isRequired={true} 
          onCompleted={() => {
            console.log("[RBD] NativeAddressFlow completed → moving to Family");
            setUiStep(10);
          }}
        />
      )}

      {uiStep === 10 && <FamilyDetailsFlow onCompleted={() => setUiStep(11)} />}

      {uiStep === 11 && <PhotoUploadFlow onCompleted={() => setUiStep(12)} />}

      {uiStep === 12 && (
        <PrivacySettingFlow
          onCompleted={() => {
            navigate("/my_matches");
          }}
        />
      )}

      </div>

      {showBackConfirm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 3000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Montserrat",
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: 420,
              background: "#fff",
              borderRadius: 16,
              padding: "22px 20px",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>
              Are you sure?
            </div>

            <div
              style={{
                fontSize: 14,
                lineHeight: "1.5",
                color: "#555",
                marginBottom: 22,
              }}
            >
              If you go back now, the information you’ve entered will not be
              saved.
              <br />
              To complete this step, you’ll need to log in again and restart
              from this point.
            </div>

            <div style={{ display: "flex", gap: 12 }}>
              <div
                onClick={confirmExitRegistration}
                style={{
                  flex: 1,
                  height: 44,
                  borderRadius: 30,
                  border: "1px solid #ddd",
                  // background:
                  //   "linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
                  backgroundColor: "rgba(234, 229, 229, 0.87)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Leave
              </div>

              <div
                onClick={cancelExitRegistration}
                style={{
                  flex: 1,
                  height: 44,
                  borderRadius: 30,

                  background:
                    "linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Stay
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RegisterBasicDetails;

/* =====================================================
   STEP 1 – PROFILE CREATED BY (API DRIVEN)
===================================================== */

const ProfileCreatedBy = ({ onNext, onSelect, uiText, value }) => {
  const [options, setOptions] = useState([]);
  // const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const [selected, setSelected] = useState(value || null);

  useEffect(() => {
    if (value) setSelected(value);
  }, [value]);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const res = await getProfileCreatedByList();
        setOptions(res.data || []);
      } catch (err) {
        console.error("Failed to fetch profile list", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  return (
    <RegistrationStepLayout
      icon={profileCreatedByIcon}
      //   title="Profile Created By"
      //   subtitle="Please Specify Who Has Created your Matrimony Profile."
      title={PROFILE_UI_CONTENT.PROFILE_CREATED_BY.title}
      subtitle={PROFILE_UI_CONTENT.PROFILE_CREATED_BY.subtitle}
      stepText="Step 1 of 6"
      //   onContinue={selected ? onNext : undefined}

      onContinue={() => {
        if (!selected) {
          setShowError(true);
          return;
        }
        onNext();
      }}
    >
      <div
        style={{
          marginTop: "40px",
          display: "flex",
          flexDirection: "column",
          gap: "18px",
          width: "100%",
        }}
      >
        {loading && <div>Loading...</div>}

        {!loading &&
          options.map((opt) => {
            const active = selected === opt.id;

            return (
              <div
                key={opt.id}
                // onClick={() => {
                //   setSelected(opt.id);
                //   onSelect(opt.id);
                // }}

                onClick={() => {
                  setSelected(opt.id);
                  onSelect(opt.id);
                  localStorage.setItem("profileCreatedById", opt.id);
                }}
                style={{
                  height: "52px",
                  borderRadius: "13px",
                  padding: "0 22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  border: active ? "none" : "1px solid #e8e6ea",
                  background: active
                    ? "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))"
                    : "#fff",
                  color: active ? "#fff" : "#000",
                  fontWeight: active ? 600 : 500,
                }}
              >
                {opt.name}
                {active && <img src={checkSmallIcon} alt="" width={20} />}
              </div>
            );
          })}
      </div>

      <Popup
        open={showError}
        type="error"
        title="Required"
        message="Please specify who has created your matrimony profile."
        onClose={() => setShowError(false)}
      />
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 2 – NAME & EMAIL
===================================================== */

const FieldRow = ({ label, required, value, onChange, error }) => {
  return (
    <div style={{ marginBottom: "22px" }}>
      {/* LABEL */}
      <div
        style={{
          fontSize: "15px",
          fontWeight: 500,
          color: "#a9a9a9",
          fontFamily: "Montserrat",
        }}
      >
        {label}
        {required && (
          <span style={{ color: "rgba(230,0,0,0.81)", fontSize: "19px" }}>
            *
          </span>
        )}
      </div>

      {/* INPUT */}
      <input
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          border: "none",
          borderBottom: `1px solid ${error ? "#ff3c3c" : "#cfcfcf"}`,
          outline: "none",
          fontSize: "15px",
          fontFamily: "Montserrat",
          paddingBottom: "6px",
          background: "transparent",
        }}
      />

      {/* ERROR */}
      {error && (
        <div
          style={{
            color: "#ff3c3c",
            fontSize: "12px",
            marginTop: "4px",
            fontFamily: "Montserrat",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

const NameEmail = ({
  onNext,
  onBack,
  onChange,
  uiText,
  onSubmit,
  title,
  subtitle,
}) => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobileNumber: "",
  });

  useEffect(() => {
    const saved = localStorage.getItem("basic_name_email");
    if (saved) {
      setForm(JSON.parse(saved));
    }
  }, []);

  // ================= REGEX =================
  const nameRegex = /^[A-Za-z]+$/;

  const firstNameStrictRegex = /^[A-Za-z]+(?:\.?\s?[A-Za-z]+)*$/;

  const emailRegex =
    //   /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    /^[a-zA-Z0-9]+([._][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/;
  const mobileRegex = /^[6-9]\d{9}$/;

  const [errors, setErrors] = useState({});

  const update = (key, val) => {
    if (key === "first_name") {
      // relaxed regex for typing (allows trailing space or dot)
      if (val && !/^[A-Za-z .]*$/.test(val)) return;

      // Auto-capitalize first letter
      if (val.length >= 1) {
        val = val.charAt(0).toUpperCase() + val.slice(1);
      }
    }

    if (key === "last_name") {
      // keep last name STRICT (no change)
      if (val && !/^[A-Za-z]*$/.test(val)) return;

      // Auto-capitalize first letter
      if (val.length >= 1) {
        val = val.charAt(0).toUpperCase() + val.slice(1);
      }
    }

    if (key === "mobileNumber") {
      if (!/^\d*$/.test(val)) return;
      if (val.length > 10) return;
      if (val.length === 1 && !/[6-9]/.test(val)) return;
    }

    // setForm((p) => ({ ...p, [key]: val }));
    setForm((p) => ({ ...p, [key]: val }));

    localStorage.setItem(
      "basic_name_email",
      JSON.stringify({ ...form, [key]: val }),
    );

    setErrors((prev) => {
      if (!prev[key]) return prev;
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const registrationMobile = localStorage.getItem("registrationMobile");

  const validate = () => {
    const e = {};

    if (!form.first_name) e.first_name = "First name is required";
    else if (form.first_name.length < 2 || form.first_name.length > 50)
      e.first_name = "First name must be 2-50 characters";
    else if (!firstNameStrictRegex.test(form.first_name)) {
      e.first_name = "Only letters, single space, and dot (.) are allowed";
    }

    if (!form.last_name) e.last_name = "Last name is required";
    else if (form.last_name.length < 2 || form.last_name.length > 50)
      e.last_name = "Last name must be 2-50 characters";
    else if (!nameRegex.test(form.last_name))
      e.last_name = "Only letters allowed, no spaces";

    if (form.email && !emailRegex.test(form.email))
      e.email = "Invalid email address";

    // if (form.mobileNumber && !mobileRegex.test(form.mobileNumber))
    //   e.mobileNumber = "Enter valid 10 digit mobile number";

    if (form.mobileNumber) {
      if (!mobileRegex.test(form.mobileNumber)) {
        e.mobileNumber = "Enter valid 10 digit mobile number";
      } else if (form.mobileNumber === registrationMobile) {
        e.mobileNumber =
          "Alternate mobile number cannot be same as registered mobile number";
      }
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  return (
    <RegistrationStepLayout
      icon={yourNameEmailIcon}
      //   title="Your Name & Email"
      //   subtitle="Enter your first, last name and email."
      title={title}
      subtitle={subtitle}
      stepText="Step 3 of 6"
      onBack={onBack}
      onContinue={async () => {
        if (!validate()) return;

        try {
          onChange(form);
          await onSubmit(form);
          onNext();
        } catch (err) {
          const apiMessage =
            err?.response?.data?.message || err?.response?.data?.error || "";

          // 🔥 MAP API ERROR TO INLINE FIELD
          if (
            apiMessage.toLowerCase().includes("alternate") &&
            apiMessage.toLowerCase().includes("mobile")
          ) {
            setErrors((prev) => ({
              ...prev,
              mobileNumber:
                "Alternate mobile number cannot be same as registered mobile number",
            }));
          }
        }
      }}
    >
      {/* CARD (UI UNCHANGED) */}
      <div
        style={{
          marginTop: "25px",
          width: "100%",
          maxWidth: "500px",
          borderRadius: "15px",
          background: "#fff",
          border: "1px solid #e8e6ea",
          padding: "20px 30px",
          boxSizing: "border-box",
        }}
      >
        <FieldRow
          label="First Name"
          required
          value={form.first_name}
          error={errors.first_name}
          onChange={(e) => update("first_name", e.target.value)}
        />

        <FieldRow
          label="Last Name"
          required
          value={form.last_name}
          error={errors.last_name}
          onChange={(e) => update("last_name", e.target.value)}
        />

        <FieldRow
          label="Email Address (Optional)"
          value={form.email}
          error={errors.email}
          onChange={(e) => update("email", e.target.value)}
        />

        <FieldRow
          label="Alternate Mobile Number (Optional)"
          value={form.mobileNumber}
          error={errors.mobileNumber}
          onChange={(e) => update("mobileNumber", e.target.value)}
        />
      </div>
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 3 – GENDER
===================================================== */

const Gender = ({ onBack, onSubmit, uiText, value, title, subtitle }) => {
  // const [selected, setSelected] = useState("");

  const [selected, setSelected] = useState(
    value || localStorage.getItem("selectedGender") || "",
  );

  useEffect(() => {
    if (value) setSelected(value);
  }, [value]);

  const [showError, setShowError] = useState(false);

  return (
    <RegistrationStepLayout
      icon={selectGenderIcon}
      //   title="Your Gender"
      //   subtitle="Choose how you identify yourself."
      title={title} // ✅ USE PROP
      subtitle={subtitle} // ✅ USE PROP
      stepText="Step 2 of 6"
      onBack={onBack}
      //   onContinue={() => selected && onSubmit(selected)}

      onContinue={() => {
        if (!selected) {
          setShowError(true);
          return;
        }

        localStorage.setItem("selectedGender", selected);
        onSubmit(selected);
      }}
    >
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          alignItems: "center",
          width: "100%",
        }}
      >
        <GenderCard
          active={selected === "F"}
          onClick={() => setSelected("F")}
          title="I AM A WOMAN"
          subtitle="TO BE BRIDE"
          image={ladkiImg}
        />
        <GenderCard
          active={selected === "M"}
          onClick={() => setSelected("M")}
          title="I AM A MAN"
          subtitle="TO BE GROOM"
          image={ladkaImg}
        />
      </div>
      <Popup
        open={showError}
        type="error"
        title="Required"
        message="Please select your gender to continue."
        onClose={() => setShowError(false)}
      />
    </RegistrationStepLayout>
  );
};

const GenderCard = ({ active, onClick, title, subtitle, image }) => (
  <div
    onClick={onClick}
    style={{
      width: "100%",
      maxWidth: "380px",
      height: "180px",
      borderRadius: "18px",
      padding: "0 24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      //   border: active ? "1.5px solid transparent" : "1px solid #e8e6ea",
      //   background: active
      //     ? "linear-gradient(180deg, rgba(255,248,242,0.88), rgba(255,238,238,0.81))"
      //     : "#fff",

      border: active ? "1.5px solid rgba(230,0,0,0.81)" : "1px solid #e8e6ea",

      background: active
        ? `
        linear-gradient(180deg, rgba(255,248,242,0.88), rgba(255,238,238,0.81)) 
       
      `
        : "#fff",

      boxSizing: "border-box",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <div style={{ fontWeight: 700 }}>{title}</div>
      <div style={{ margin: "10px 0", color: "#a9a9a9" }}>OR</div>
      <div style={{ fontWeight: 700 }}>{subtitle}</div>
    </div>
    <img src={image} alt="" style={{ height: "140px" }} />
  </div>
);

/* =====================================================
   STEP 4 & 5 – DOB / TOB (Scrollable Wheels)
===================================================== */

const DobTimeStep = ({ onBack, onSubmit, title, subtitle, onModeChange }) => {
  const [mode, setMode] = useState("DATE");

  useEffect(() => {
    onModeChange?.(mode);
  }, [mode]);

  /* =====================================================
     1️⃣ GENDER — SINGLE SOURCE OF TRUTH
     ===================================================== */
  // Stored after /profiles/register response (Mxxxxx / Fxxxxx)
  const profileGender = localStorage.getItem("profileGender") || "M";

  /* =====================================================
     2️⃣ AGE RULES
     ===================================================== */
  const MIN_AGE = profileGender === "F" ? 18 : 21;

  // Latest allowed DOB
  const maxAllowedDate = dayjs().subtract(MIN_AGE, "year");

  /* =====================================================
     3️⃣ INITIAL SAFE STATE
     ===================================================== */
  const [year, setYear] = useState(maxAllowedDate.year());
  const [month, setMonth] = useState(maxAllowedDate.month() + 1);
  const [day, setDay] = useState(maxAllowedDate.date());

  const [hour, setHour] = useState(11);
  const [minute, setMinute] = useState(0);
  const [ampm, setAmpm] = useState("AM");

  /* =====================================================
     4️⃣ WHEEL VALUES
     ===================================================== */
  const START_YEAR = 1950;
  const END_YEAR = maxAllowedDate.year();

  const years = Array.from(
    { length: END_YEAR - START_YEAR + 1 },
    (_, i) => START_YEAR + i,
  );

  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const daysInMonth = dayjs(`${year}-${month}-01`).daysInMonth();

  /* =====================================================
     5️⃣ HARD CLAMPS (CRITICAL FIX)
     ===================================================== */

  // Clamp day for month (Feb, leap year, etc.)
  useEffect(() => {
    if (day > daysInMonth) {
      setDay(daysInMonth);
    }
  }, [year, month, daysInMonth]);

  // Clamp future-invalid dates
  useEffect(() => {
    if (year === maxAllowedDate.year()) {
      if (month > maxAllowedDate.month() + 1) {
        setMonth(maxAllowedDate.month() + 1);
      }

      if (month === maxAllowedDate.month() + 1 && day > maxAllowedDate.date()) {
        setDay(maxAllowedDate.date());
      }
    }
  }, [year, month, day, maxAllowedDate]);

  /* =====================================================
   6️⃣ AGE CALCULATION (DERIVED)
===================================================== */

  const selectedDOB = dayjs(`${year}-${month}-${day}`);
  const calculatedAge = dayjs().diff(selectedDOB, "year");

  const displayAge = Math.max(calculatedAge, MIN_AGE);

  /* =====================================================
     6️⃣ SUBMIT
     ===================================================== */

  const handleContinue = () => {
    const dateOfBirth = dayjs(`${year}-${month}-${day}`).format("YYYY-MM-DD");

    // 1️⃣ If user is on DATE → go to TIME
    if (mode === "DATE") {
      setMode("TIME");
      return;
    }

    // 2️⃣ If user is on TIME → submit with time
    const timeOfBirth = `${String(hour).padStart(2, "0")}:${String(
      minute,
    ).padStart(2, "0")} ${ampm}`;

    onSubmit({ dateOfBirth, timeOfBirth });
  };

  const infoBoxStyle = {
    marginTop: 110,
    width: "100%",
    padding: 10,
    border: "1px dashed rgba(230,0,0,0.5)",
    borderRadius: 12,
    fontSize: 12,
    color: "#555",
    textAlign: "center",
  };

  return (
    <RegistrationStepLayout
      icon={calendarIcon}
      title={title}
      subtitle={subtitle}
      stepText="Step 4 of 6"
      onBack={onBack}
      onContinue={handleContinue}
    >
      {/* <CapsuleToggle mode={mode} setMode={setMode} /> */}

      <SegmentToggle mode={mode} setMode={setMode} />

      {/* ===== AGE CALCULATOR ===== */}
      {mode === "DATE" && (
        <div
          style={{
            marginTop: 25,
            display: "flex",
            justifyContent: "center",
            alignSelf: "center",
          }}
        >
          <div
            style={{
              padding: "10px 18px",
              borderRadius: 20,
              background: "#FFF1F1",
              border: "1px solid rgba(230,0,0,0.3)",
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(230,0,0,0.9)",
            }}
          >
            Your age: {calculatedAge} years
          </div>
        </div>
      )}

      <div
        style={{
          marginTop: 75,
          display: "flex",
          justifyContent: "center",
          alignSelf: "center",
        }}
      >
        <ActiveCapsule>
          <div style={{ display: "flex", gap: 70 }}>
            {mode === "DATE" ? (
              <>
                <WheelScroller values={years} value={year} onChange={setYear} />
                <WheelScroller
                  values={months}
                  value={month}
                  onChange={setMonth}
                  formatter={(m) =>
                    dayjs()
                      .month(m - 1)
                      .format("MMM")
                  }
                />
                <WheelScroller
                  values={Array.from({ length: daysInMonth }, (_, i) => i + 1)}
                  value={day}
                  onChange={setDay}
                />
              </>
            ) : (
              <>
                <WheelScroller
                  values={Array.from({ length: 12 }, (_, i) => i + 1)}
                  value={hour}
                  onChange={setHour}
                />
                <WheelScroller
                  values={Array.from({ length: 60 }, (_, i) => i)}
                  value={minute}
                  onChange={setMinute}
                  formatter={(m) => String(m).padStart(2, "0")}
                />
                <WheelScroller
                  values={["AM", "PM"]}
                  value={ampm}
                  onChange={setAmpm}
                />
              </>
            )}
          </div>
        </ActiveCapsule>
      </div>

      {mode === "TIME" && (
        <>
          <div
            style={{
              ...infoBoxStyle,
              display: "flex",
              alignItems: "flex-start",
              gap: 12,
            }}
          >
            <img
              src={infoIcon}
              alt="info"
              style={{
                width: 22,
                height: 22,
                flexShrink: 0,
                marginTop: 0,
              }}
            />

            <span style={{ lineHeight: "1.98", textAlign: "left" }}>
              Birth time is used for horoscope matching and kundali generation.
              If not known, you may ask family members. This field is optional
              and you can proceed without it.
            </span>
          </div>

          <SkipTime
            onSkip={() =>
              onSubmit({
                dateOfBirth: dayjs(`${year}-${month}-${day}`).format(
                  "YYYY-MM-DD",
                ),
                timeOfBirth: "",
              })
            }
          />
        </>
      )}
    </RegistrationStepLayout>
  );
};

const CapsuleToggle = ({ mode, setMode }) => {
  return (
    <div
      style={{
        marginTop: "20px",
        width: "190px",
        height: "37px",
        borderRadius: "50px",
        border: "1px solid rgba(230,0,0,0.81)",
        display: "flex",
        position: "relative",
        fontSize: "13px",
        overflow: "hidden",
        alignSelf: "center",
      }}
    >
      <div
        onClick={() => setMode("DATE")}
        style={{
          width: "50%",
          background:
            mode === "DATE"
              ? "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))"
              : "transparent",
          color: mode === "DATE" ? "#fff" : "#525151",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Date
      </div>

      <div
        onClick={() => setMode("TIME")}
        style={{
          width: "50%",
          background:
            mode === "TIME"
              ? "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))"
              : "transparent",
          color: mode === "TIME" ? "#fff" : "#525151",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Time
      </div>
    </div>
  );
};

const SegmentToggle = ({ mode, setMode }) => {
  const isDate = mode === "DATE";

  return (
    <div
      style={{
        width: 170,
        height: 36,
        borderRadius: 50,
        border: "1px solid rgba(230,0,0,0.8)",
        display: "flex",
        overflow: "hidden",
        marginTop: "20px",
        alignSelf: "center",
      }}
    >
      <SegmentButton
        text="Date"
        active={isDate}
        onClick={() => setMode("DATE")}
      />
      <SegmentButton
        text="Time"
        active={!isDate}
        onClick={() => setMode("TIME")}
      />
    </div>
  );
};

const SegmentButton = ({ text, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: 50,
      background: active
        ? "linear-gradient(90deg, #FF7705, #E60000)"
        : "transparent",
      color: active ? "#fff" : "#000",
      fontWeight: 600,
      fontSize: 14,
      transition: "all 0.25s ease",
    }}
  >
    {text}
  </div>
);

const ActiveCapsule = ({ children }) => (
  <div
    style={{
      width: "400px",
      height: "52px",
      borderRadius: "50px",
      background: `
        linear-gradient(180deg, rgba(255,248,242,0.88), rgba(255,238,238,0.81)) padding-box,
        linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81)) border-box
      `,
      border: "1px solid transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {children}
  </div>
);

const SkipTime = ({ onSkip }) => {
  return (
    <div
      onClick={onSkip}
      style={{
        marginTop: "20px",
        width: "400px",
        height: "50px",
        borderRadius: "50px",
        background:
          "linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81)) border-box",
        border: "1px solid transparent",
        color: "rgba(230,0,0,0.81)",
        fontSize: "12px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        alignSelf: "center",
      }}
    >
      Skip for now
    </div>
  );
};

/* =====================================================
   STEP 6 – MARITAL STATUS
===================================================== */

const MaritalStatusStep = ({ onBack, onNext, uiText, title, subtitle }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await getMaritalStatusList();
        setOptions(
          (res.data || []).filter(
            (s) => s.isActive === 1 && s.status !== "Any",
          ),
        );
      } catch (e) {
        console.error("Failed to load marital status", e);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  const handleContinue = async () => {
    if (!selected) return;

    try {
      setSubmitting(true);
      await addMaritalStatus(selected.id);
      onNext(selected.status);
    } catch (e) {
      console.error("Failed to save marital status", e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RegistrationStepLayout
      icon={MaritalStatusIcon}
      // title={uiText?.[6]?.title}
      // subtitle={uiText?.[6]?.subtitle}

      title={title}
      subtitle={subtitle}
      stepText="Step 5 of 6"
      //   onBack={onBack}
      //   onContinue={!submitting && selected ? handleContinue : undefined}

      onContinue={() => {
        if (!selected) {
          setShowError(true);
          return;
        }
        handleContinue();
      }}
    >
      {loading && <div>Loading...</div>}

      {!loading && (
        <div
          style={{
            marginTop: "40px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            rowGap: "14px",
            columnGap: "8px",
            width: "100%",
            maxWidth: "420px",
            alignSelf: "center",
          }}
        >
          {options.map((opt, index) => {
            const active = selected?.id === opt.id;
            const isRight = index % 2 === 1;

            return (
              <div
                key={opt.id}
                style={{
                  gridColumn: isRight ? "2 / 3" : "1 / 2",
                  marginTop: isRight ? 60 : 0, // 👈 stagger
                }}
              >
                <div
                  onClick={() => setSelected(opt)}
                  style={{
                    height: "54px",
                    borderRadius: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontWeight: 600,
                    border: active
                      ? "1px solid transparent"
                      : "1px solid #e8e6ea",
                    color: active ? "#fff" : "#525151",
            //         background: active
            //           ? `
            //   linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81)) padding-box,
            //   linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81)) border-box
            // `
            //           : "#fff",

            background: active
  ? `
      linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.29)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) border-box
    `
  : "#fff",
                    boxShadow: active
                      ? "0px 12px 18px rgba(230,0,0,0.25)"
                      : "none",
                    opacity: submitting ? 0.6 : 1,
                    transition: "all 0.25s ease",
                  }}
                >
                  {opt.status}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Popup
        open={showError}
        type="error"
        title="Required"
        message="Please select your marital status."
        onClose={() => setShowError(false)}
      />
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 7 – CHILDREN DETAILS
===================================================== */

const ChildrenDetailsStep = ({ onBack, onNext, uiText, title, subtitle }) => {
  const [count, setCount] = useState("");
  const [livingStatus, setLivingStatus] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const countOptions = ["None", "1", "2", "3", "4+"];

  const mapCountToNumber = (val) => {
    if (val === "None") return 0;
    if (val === "4+") return 5;
    return Number(val);
  };

  const handleContinue = async () => {
    if (!count) {
      setErrorMsg("Please select number of children.");
      setShowError(true);
      return;
    }

    if (count !== "None" && !livingStatus) {
      setErrorMsg("Please select children living status.");
      setShowError(true);
      return;
    }

    let payload;

    if (count === "None") {
      payload = { numberOfChildren: "None" };
    } else {
      payload = {
        numberOfChildren: count === "4+" ? 5 : Number(count),
        childrenLivingStatus: livingStatus,
      };
    }

    try {
      setSubmitting(true);
      await addChildrenDetails(payload);
      onNext();
    } catch (e) {
      console.error("Failed to save children details", e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RegistrationStepLayout
      icon={ChildrenDetailsIcon}
      // title={uiText?.[7]?.title}
      // subtitle={uiText?.[7]?.subtitle}

      title={title}
      subtitle={subtitle}
      stepText="Step 5 of 6"
      onBack={onBack}
      //   onContinue={
      //     !submitting && count && (count === "None" || livingStatus)
      //       ? handleContinue
      //       : undefined
      //   }

      onContinue={handleContinue}
    >
      {/* Number of Children */}
      <div style={{ marginTop: "30px", width: "100%" }}>
        <div style={{ fontWeight: 600, marginBottom: "16px" }}>
          Number of Children
        </div>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          {countOptions.map((opt) => {
            const active = count === opt;

            return (
              <div
                key={opt}
                onClick={() => {
                  setCount(opt);
                  if (opt === "None") setLivingStatus("");
                }}
                style={{
                  width: "140px",
                  height: "47px",
                  borderRadius: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontWeight: 600,
                  border: "1px solid #e8e6ea",
                  // background: active
                  //   ? "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))"
                  //   : "#fff",

                   background: active
  ? `
      linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.29)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) border-box
    `
  : "#fff",
                  color: active ? "#fff" : "#000",
                }}
              >
                {opt}
              </div>
            );
          })}
        </div>
      </div>

      {/* Living Status (ONLY if children > 0) */}
      {count && count !== "None" && (
        <div style={{ marginTop: "40px", width: "100%" }}>
          <div style={{ fontWeight: 600, marginBottom: "16px" }}>
            Children living Status
          </div>

          {["Living with me", "Not Living with me"].map((opt) => {
            const active = livingStatus === opt;

            return (
              <div
                key={opt}
                onClick={() => setLivingStatus(opt)}
                style={{
                  height: "53px",
                  borderRadius: "50px",
                  marginBottom: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontWeight: 600,
                  border: "1px solid #e8e6ea",
                  background: active
  ? `
      linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.29)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) padding-box, 
      linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81)) border-box
    `
  : "#fff",
                  color: active ? "#fff" : "#000",
                }}
              >
                {opt}
              </div>
            );
          })}
        </div>
      )}

      <Popup
        open={showError}
        type="error"
        title="Required"
        message={errorMsg}
        onClose={() => setShowError(false)}
      />
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 8 – HEIGHT & WEIGHT
===================================================== */

const HeightWeightStep = ({ onBack, onSubmit, uiText, title, subtitle }) => {
  const [showHeight, setShowHeight] = useState(false);
  const [showWeight, setShowWeight] = useState(false);

  const [selectedHeight, setSelectedHeight] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState(null);

  const [heightList, setHeightList] = useState([]);
  const [weightList, setWeightList] = useState([]);

  const [heightError, setHeightError] = useState("");

  // 🔹 FETCH MASTER DATA
  useEffect(() => {
    getHeightList().then((res) => {
      setHeightList(res.data || []);
    });

    getWeightList().then((res) => {
      setWeightList(res.data || []);
    });
  }, []);

  // const handleContinue = async () => {
  //   if (!selectedHeight) return;

  //   const payload = {
  //     heightId: selectedHeight.id,
  //     weightId: selectedWeight ? selectedWeight.id : "",
  //   };

  //   try {
  //     await submitHeightWeight(payload);
  //     onSubmit(); // move to next flow
  //   } catch (e) {
  //     console.error("Failed to submit height & weight", e);
  //   }
  // };


const handleContinue = async () => {
  if (!selectedHeight) return;

  console.log("Selected Height:", selectedHeight);
  console.log("Selected Weight:", selectedWeight);

  const payload = {
    heightId: selectedHeight.heightId || selectedHeight.id,
    ...(selectedWeight?.weightId && {
      weightId: selectedWeight.weightId,
    }),
  };

  console.log("Submitting payload:", payload);

  try {
    await submitHeightWeight(payload);
    onSubmit();
  } catch (e) {
    console.error("Failed to submit height & weight", e);
  }
};


  return (
    <RegistrationStepLayout
      icon={YourHeightIcon}
      // title={uiText?.[8]?.title}
      // subtitle={uiText?.[8]?.subtitle}

      title={title}
      subtitle={subtitle}
      stepText="Step 6 of 6"
      //   onContinue={selectedHeight ? handleContinue : undefined}
      onContinue={async () => {
        if (!selectedHeight) {
          setHeightError("Please select your height");
          return;
        }

        setHeightError("");

        await handleContinue(); // ✅ submits API
      }}
      continueVariant="button"
    >
      {/* HEIGHT INPUT */}
      <div style={{ position: "relative", zIndex: 5, width: "100%" }}>
        <DropdownInput
          label={selectedHeight ? selectedHeight.height : "Select Height"}
          open={showHeight}
          onClick={() => {
            setShowHeight(!showHeight);
            setShowWeight(false);
          }}
        />

        {heightError && (
          <div
            style={{
              color: "#ff3c3c",
              fontSize: "12px",
              marginTop: "6px",
              fontFamily: "Montserrat",
            }}
          >
            {heightError}
          </div>
        )}

        {showHeight && (
          <DropdownOverlay
            data={heightList}
            labelKey="height"
            onClose={() => setShowHeight(false)}
            onSelect={(item) => {
              setSelectedHeight(item);
              setHeightError("");
              setShowHeight(false);
            }}
          />
        )}
      </div>

      {/* WEIGHT INPUT */}
      <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
        <DropdownInput
          label={
            selectedWeight ? selectedWeight.weight : "Select Weight (optional)"
          }
          open={showWeight}
          onClick={() => {
            setShowWeight(!showWeight);
            setShowHeight(false);
          }}
        />

        {showWeight && (
          <DropdownOverlay
            data={weightList}
            labelKey="weight"
            onClose={() => setShowWeight(false)}
            onSelect={(item) => {
              setSelectedWeight(item);
              setShowWeight(false);
            }}
          />
        )}
      </div>
    </RegistrationStepLayout>
  );
};

const DropdownInput = ({ label, open, onClick }) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{
        marginTop: 40,
        width: "100%",
        height: 57,
        borderRadius: 13,
        border: "1px solid #e8e6ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        cursor: "pointer",
        fontWeight: 500,
        color: "rgba(0,0,0,0.7)",
      }}
    >
      {label}
      <img src={open ? upArrow : downArrow} alt="" width={18} />
    </div>
  );
};

const DropdownOverlay = ({ data, labelKey, onClose, onSelect }) => {
  const ref = useRef();
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const filteredData = data.filter((item) =>
    item[labelKey].toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div
      ref={ref}
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        top: 110,
        left: 0,
        width: "100%",
        maxWidth: 500,
        height: 280,
        borderRadius: 15,
        background: "#fffcfb",
        border: "1px solid #e8e6ea",
        animation: "fadeIn 0.2s ease",

        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 10,
      }}
    >
      {/* SEARCH */}
      <div
        style={{
          margin: 15,
          height: 43,
          borderRadius: 50,
          border: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 10,
          boxShadow: "0px 4px 12px rgba(13,10,44,0.06)",
        }}
      >
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search ..."
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: 13,
          }}
        />
        <img src={searchIcon} alt="" width={28} />
      </div>

      {/* LIST */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: 1,
        }}
      >
        {filteredData.map((item, i) => (
          <div key={i}>
            <div
              onClick={() => onSelect(item)}
              style={{
                padding: "14px 45px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {item[labelKey]}
            </div>

            {/* ✅ Divider only BETWEEN items */}
            {i !== filteredData.length - 1 && (
              <div
                style={{
                  height: 1.2,
                  margin: "1px 35px",
                  background:
                    "linear-gradient(90deg, rgba(255,119,5,0), rgba(230, 0, 0, 0.53), rgba(255,119,5,0))",
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
